import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

const initState = {
  workers: null,
  assignObjectIds: {},
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const workers = data;
  const assignObjectIds = {};

  workers.forEach(item => {
    assignObjectIds[item.id] = false;
  });

  return {
    ...state,
    workers,
    assignObjectIds,
    loading: false,
  };
}

function onChangeChecked(state, { payload }) {
  const { id, value } = payload;
  const { assignObjectIds } = state;

  if (id === 'all') {
    const arrayOfIds = Object.keys(assignObjectIds);

    if (arrayOfIds.length > 0) {
      arrayOfIds.forEach(key => {
        assignObjectIds[key] = value;
      });
    }
  } else {
    assignObjectIds[id] = value;
  }

  return {
    ...state,
    assignObjectIds,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_CHECKED]: onChangeChecked,
});
